import React, { useState } from "react";
import axios from "axios";

function AdminTable({ grievances, onReplySubmitted }) {
  const [selectedGrievance, setSelectedGrievance] = useState(null);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailDescription, setEmailDescription] = useState("");
  const [sending, setSending] = useState(false);

  const token = localStorage.getItem("adminToken");
  const API_BASE = "https://grs.jeccac.in/api";

  const allowedStatuses = ["Pending", "In Review", "Resolved", "Closed"];

  const handleOpenEmailModal = (g) => {
    setSelectedGrievance(g);
    setEmailSubject(`Reply to your grievance (${g.grievanceNo})`);
    setEmailDescription(g.adminReply || "");
  };

  const handleCloseModal = () => {
    setSelectedGrievance(null);
    setEmailSubject("");
    setEmailDescription("");
  };

  const handleStatusChange = async (id, newStatus) => {
    if (!window.confirm("Are you sure you want to update the status?")) return;

    // Fallback: we just update status and keep the old reply
    const currentGrievance = grievances.find((g) => g._id === id);
    try {
      await axios.post(
        `${API_BASE}/admin/reply/${id}`,
        {
          reply: currentGrievance.adminReply || "Status updated",
          status: newStatus,
        },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );
      onReplySubmitted?.();
    } catch (err) {
      alert("Failed to update status.");
    }
  };

  const handleSendEmail = async () => {
    if (!emailDescription.trim()) {
      alert("Please enter a description/reply.");
      return;
    }

    setSending(true);
    try {
      const res = await axios.post(
        `${API_BASE}/admin/reply/${selectedGrievance._id}`,
        {
          reply: emailDescription,
          status: selectedGrievance.status || "Resolved",
          subject: emailSubject,
        },
        { headers: token ? { Authorization: `Bearer ${token}` } : {} }
      );

      const { emailSent, emailError } = res.data || {};
      if (emailSent) {
        alert("Email sent successfully.");
      } else if (emailError) {
        alert(`Grievance updated, but email was NOT sent.\n${emailError}`);
      } else {
        alert("Grievance updated successfully.");
      }

      handleCloseModal();
      onReplySubmitted?.();
    } catch (err) {
      alert("Failed to send reply.");
    } finally {
      setSending(false);
    }
  };

  const handleDeleteGrievance = async (id, grievanceNo) => {
    if (
      !window.confirm(
        `Are you sure you want to delete grievance ${grievanceNo || ""}?`
      )
    )
      return;
    try {
      await axios.delete(`${API_BASE}/admin/grievances/${id}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      alert("Grievance deleted successfully.");
      onReplySubmitted?.();
    } catch (err) {
      alert("Failed to delete grievance.");
    }
  };

  return (
    <>
      <div className="table-responsive">
        <table className="admin-table">
          <thead>
            <tr>
              <th>
                SL NO{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                NAME{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                CATEGORY{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                ADMN NO{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                EMAIL{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                PHONE NO{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                GRIEVANCE TYPE{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                DETAILS{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                REPLY{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                STATUS{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
              <th>
                ACTIONS{" "}
                <span style={{ fontSize: "0.6rem", color: "#ccc" }}>▲</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {grievances.map((g, index) => (
              <tr key={g._id}>
                <td>{index + 1}</td>
                <td>{g.name}</td>
                <td>{g.category}</td>
                <td>{g.admissionNo || "-"}</td>
                <td>{g.email}</td>
                <td>{g.mobile}</td>
                <td>{g.grievanceType}</td>
                <td
                  style={{
                    maxWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {g.description}
                </td>
                <td>
                  <button
                    className="reply-btn"
                    onClick={() => handleOpenEmailModal(g)}
                  >
                    Reply
                  </button>
                </td>
                <td>
                  <select
                    className="status-select"
                    value={g.status || "Pending"}
                    onChange={(e) => handleStatusChange(g._id, e.target.value)}
                  >
                    {allowedStatuses.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <button
                    className="delete-btn"
                    onClick={() => handleDeleteGrievance(g._id, g.grievanceNo)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {grievances.length === 0 && (
              <tr>
                <td
                  colSpan="11"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No grievances found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Email Modal */}
      {selectedGrievance && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>Email</h3>
              <button className="modal-close" onClick={handleCloseModal}>
                &times;
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group">
                <label>Subject:</label>
                <input
                  type="text"
                  className="form-control"
                  value={emailSubject}
                  onChange={(e) => setEmailSubject(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label>Description:</label>
                <textarea
                  className="form-control"
                  rows="6"
                  value={emailDescription}
                  onChange={(e) => setEmailDescription(e.target.value)}
                  style={{ resize: "vertical" }}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn-secondary"
                onClick={handleCloseModal}
                disabled={sending}
              >
                Close
              </button>
              <button
                className="btn-primary"
                onClick={handleSendEmail}
                disabled={sending}
              >
                {sending ? "Sending..." : "Send message"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AdminTable;
